import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/firebase";

import "./Verificacoes.css";

export default function VerificacoesAprovadas() {
  const [lista, setLista] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    const snap = await getDocs(collection(db, "users"));

    const approved = snap.docs
      .map((d) => ({ 
        id: d.id, 
        name: d.data().name || d.data().displayName || d.data().userName || "Usuário sem nome",
        profession: d.data().profession || "",
        verifyPhrase: d.data().verifyPhrase || "",
        verifySelfieUrl: d.data().verifySelfieUrl || "",
        verificationStatus: d.data().verificationStatus || "none",
        verifiedAt: d.data().verificationReviewedAt || d.data().updatedAt || null
      }))
      .filter((v) => v.verificationStatus === "verified");

    setLista(approved);
  }

  // Filtrar por termo de busca
  const filteredLista = lista.filter(v =>
    v.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (v.profession && v.profession.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  function formatDate(date) {
    if (!date) return "-";
    try {
      if (typeof date.toDate === "function") {
        return date.toDate().toLocaleString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
      if (date instanceof Date) {
        return date.toLocaleString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
      return "-";
    } catch {
      return "-";
    }
  }

  return (
    <div className="verif-container">
      <h2 className="title">Verificações Aprovadas</h2>
      
      {/* Barra de busca */}
      <div className="controls-bar">
        <input 
          type="text" 
          className="search-input" 
          placeholder="Buscar por nome ou profissão..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <div style={{ fontSize: '14px', color: '#666' }}>
          {filteredLista.length} de {lista.length} aprovados
        </div>
      </div>

      {filteredLista.length === 0 ? (
        <div className="no-data">
          <p>{searchTerm ? "Nenhuma verificação aprovada encontrada para sua busca." : "Nenhuma verificação aprovada encontrada."}</p>
        </div>
      ) : (
        <table className="verif-table">
          <thead>
            <tr>
              <th>Usuário</th>
              <th>Profissão</th>
              <th>Aprovado em</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredLista.map((v) => (
              <tr key={v.id}>
                <td>
                  <div style={{ fontWeight: '600' }}>{v.name}</div>
                  {v.verifyPhrase && (
                    <div style={{ fontSize: '12px', color: '#666', marginTop: '4px', fontStyle: 'italic' }}>
                      "{v.verifyPhrase}"
                    </div>
                  )}
                </td>
                <td>{v.profession || "—"}</td>
                <td>{formatDate(v.verifiedAt)}</td>
                <td>
                  <span className="status verified">Verificado</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}